import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Row, Button } from "antd";
import "antd/lib/row/style";

import logo from "./no-auth.png";
import "./VhNoAuth.scss";

/**
 * 属性声明
 *
 * @interface VhNoAuthProps
 */
export interface VhNoAuthProps {
  /**
   * 返回首页地址
   * 绝对路径，http开头链接
   * 相对路径，react路由
   *
   * @type {string}
   * @memberof VhNoAuthProps
   */
  homePage?: string;
}

/**
 * 无权限页面
 * @class VhNoAuth
 * @extends {React.Component}
 */
class VhNoAuth extends React.Component<VhNoAuthProps & RouteComponentProps> {
  /**
   * 返回首页
   *
   * @memberof VhNoAuth
   */
  public onReturn = () => {
    if (this.props.homePage) {
      if (this.props.homePage.startsWith("http")) {
        window.location.href = this.props.homePage;
      } else {
        this.props.history.push({pathname: this.props.homePage});
      }
    } else {
      window.location.href = `${ process.env.REACT_APP_ENV === "pro" ? "https" : "http" }://${ process.env.REACT_APP_ENV !== "pro" ? process.env.REACT_APP_ENV : "" }home.viphrm.com`;
    }
  }

  /**
   * 渲染
   *
   * @returns
   * @memberof VhNoAuth
   */
  public render() {
    return (
      <Row className="vh-exception">
        <img src={ logo } alt="no-auth" />
        <div style={ {marginTop: 32} }>抱歉，您无权访问该页面</div>
        <div style={ {color: "#999"} }>请联系您公司的系统管理员确认</div>
        <div style={ {marginTop: 32} }>
          <Button type="primary" shape="round" ghost={ true } onClick={ this.onReturn }>返回首页</Button>
        </div>
      </Row>
    )
  }
}

export default withRouter(VhNoAuth);
